exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#main-menu[data-v-06d4d2d9] {\n  width: 100%;\n  max-width: 350px;\n  padding-top: 50px;\n}\n", ""]);

// exports
